import { render, staticRenderFns } from "./changelog.vue?vue&type=template&id=50ae41ba&scoped=true"
import script from "./changelog.vue?vue&type=script&lang=js"
export * from "./changelog.vue?vue&type=script&lang=js"
import style0 from "./changelog.styl?vue&type=style&index=0&id=50ae41ba&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ae41ba",
  null
  
)

export default component.exports